import ContasPagarLista from '@/pages/contaspagar/ContasPagarLista';
import ContasPagarForm from '@/pages/contaspagar/ContasPagarForm';
import CategoriasLista from '@/pages/contaspagar/categorias/CategoriasLista';
import ExtratoFornecedor from '@/pages/contaspagar/ExtratoFornecedor.vue';
import PagamentoFornecedor from '@/pages/contaspagar/PagamentoFornecedor.vue';

export default [
    {
      path: '/financeiro/contaspagar',
      name: 'ContasPagarLista',
      component: ContasPagarLista,
    },
    {
      path: '/financeiro/contaspagar/adicionar',
      name: 'ContasPagarAdicionar',
      component: ContasPagarForm,
    },
    {
      path: '/financeiro/categorias',
      name: 'CategoriasLista',
      component: CategoriasLista,
    },
    {
      path: '/financeiro/extratofornecedor/:id?',
      name: 'ExtratoFornecedor',
      component: ExtratoFornecedor,
    },
    {
      path: '/financeiro/extratofornecedor/pagamento',
      name: 'PagamentoFornecedor',
      component: PagamentoFornecedor,
    },
];
